import { useAuthStep } from "@/hooks/useAuthStep";
import { useCommunication } from "@/lib/CommunicationWrapper";
import { AnimatePresence, motion } from "framer-motion";
import { Check } from "lucide-react";
import { useState } from "react";

export const PreviouslyAppliedTheme = () => {

    const { updateOptions, sendMessage } = useCommunication();

    const { previouslyAppliedTheme, setAuthStep, postReapplyHandler, loginState, handleAuthFinish } = useAuthStep();

    const [clicked, setClicked] = useState(false);

    const nextStep = () => {
        if (loginState.type === "signup") {
            setAuthStep("claimTrial");
        } else {
            handleAuthFinish();
        }
    }

    const handleApplyTheme = () => {
        setClicked(!clicked);

        updateOptions({
            "selected_theme": {
                "title": previouslyAppliedTheme.title,
                "code": previouslyAppliedTheme.code,
                "category": previouslyAppliedTheme.category,
                "exports": previouslyAppliedTheme.exports,
            },
        });

        sendMessage({
            type: "LOAD_THEME",
            payload: { "exports": JSON.parse(previouslyAppliedTheme.exports) },
        });
    }


    return (
        <div className="px-[30px] mb-[30px] flex flex-col h-full text-gray-500">
            <div>
                <h1 className="text-2xl font-semibold text-black mb-[5px]">Let's get you back on track</h1>
                <p className="text-gray-500 text-sm">It looks like you've applied a theme before. Would you like to reapply it?</p>
            </div>

            <div className="flex-1 flex items-center justify-center">
                <div className="flex flex-col items-center justify-center">
                    <img src={previouslyAppliedTheme.preview} alt="logo" className="h-30 w-48 object-cover rounded-xl" />
                    <p className="text-black text-center text-sm mt-2">{previouslyAppliedTheme.title}</p>
                    <button
                        onClick={handleApplyTheme}
                        className={`w-[120px] flex items-center justify-center ${clicked ? "bg-green-500" : "bg-blue-500"} font-medium text-white text-sm mt-2 py-2 px-4 rounded-lg overflow-hidden transition-all duration-200 ease-out ${clicked ? "gap-1" : "gap-0"}`}
                    >
                        <AnimatePresence mode="wait">
                            {clicked && (
                                <motion.div
                                    key="check"
                                    initial={{ opacity: 0, width: 0, marginRight: 0 }}
                                    animate={{ opacity: 1, width: 16, marginRight: 0 }}
                                    exit={{ opacity: 0, width: 0, marginRight: 0 }}
                                    transition={{ duration: 0.1, ease: "easeOut" }}
                                    className="flex-shrink-0"
                                >
                                    <Check className="size-4" />
                                </motion.div>
                            )}
                        </AnimatePresence>
                        <motion.span initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} transition={{ duration: 0.15, ease: "easeOut" }}>
                            {clicked ? "Done" : "Reapply"}
                        </motion.span>
                    </button>

                </div>
            </div>

            <div className="flex flex-col gap-[10px]">
                <button
                    style={{ background: "linear-gradient(90deg, #ffa952,#ff686c)" }}
                    className="flex items-center justify-center gap-[8px] py-[12px] rounded-full w-full font-medium text-white"
                    onClick={() => nextStep()}
                >
                    {clicked ? "Next" : "Skip"}
                </button>
            </div>
        </div >
    )
}